import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';

import {Tab, Tabs} from '@pb/kit-component-tabs-v2';
import {useGateValue} from '@pb/kit-lib-statsig';

import type {ValueOf} from 'src/typedef';

export const MANAGE_ENTITLEMENTS_TABS = {
    ROLES_GRANTS: 'roles-grants',
    PRESETS: 'presets',
    DATASET_ENTITLEMENTS: 'dataset-entitlements',
};

export const MANAGE_ENTITLEMENTS_TABS_CAPTIONS = {
    [MANAGE_ENTITLEMENTS_TABS.ROLES_GRANTS]: 'Roles, Grants & Resources',
    [MANAGE_ENTITLEMENTS_TABS.PRESETS]: 'Presets',
    [MANAGE_ENTITLEMENTS_TABS.DATASET_ENTITLEMENTS]: 'Dataset Entitlements',
};

type Props = {
    activeTab: ValueOf<typeof MANAGE_ENTITLEMENTS_TABS>,
    disabled?: boolean,
};

export const ManageEntitlementsTabs = ({activeTab, disabled}: Props) => {
    const navigate = useNavigate();
    const {hasAccess} = useAdminAccessRight();
    const isDatasetEntitlementsEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);

    const redirectToTab = useCallback((tab: ValueOf<typeof MANAGE_ENTITLEMENTS_TABS>) => {
        if (!disabled) {
            navigate(`/entitlements/${tab}`);
        }
    }, [navigate, disabled]);

    return (
        <Tabs style={{paddingLeft: 8, width: '100%'}} onChange={redirectToTab} value={activeTab}>
            <Tab
                disabled={disabled}
                value={MANAGE_ENTITLEMENTS_TABS.ROLES_GRANTS}
                caption={MANAGE_ENTITLEMENTS_TABS_CAPTIONS[MANAGE_ENTITLEMENTS_TABS.ROLES_GRANTS]}
            />
            {hasAccess(ACCESS_RIGHTS.MANAGE_ENTITLEMENT_PRESET) ? (
                <Tab
                    disabled={disabled}
                    value={MANAGE_ENTITLEMENTS_TABS.PRESETS}
                    caption={MANAGE_ENTITLEMENTS_TABS_CAPTIONS[MANAGE_ENTITLEMENTS_TABS.PRESETS]}
                />
            ) : null}
            {isDatasetEntitlementsEnabled ? (
                <Tab
                    disabled={disabled}
                    value={MANAGE_ENTITLEMENTS_TABS.DATASET_ENTITLEMENTS}
                    caption={MANAGE_ENTITLEMENTS_TABS_CAPTIONS[MANAGE_ENTITLEMENTS_TABS.DATASET_ENTITLEMENTS]}
                />
            ) : null}
        </Tabs>
    );
};
